import searchimg from '../../assets/images/icons/search.svg';
import { searchData } from '../../constants/HomePageData';
import SingleSearchGun from '../SingleSearchGun/SingleSearchGun';
import styles from './SearchSection.module.css';


const SearchSection = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className={styles.searchWrapper}>
                        <form>
                            <div className={styles.formWrapper}>
                                <input type="search" placeholder="Find your weapon here" />
                                <img src={searchimg} alt="" />
                            </div>
                        </form>
                        <div className={styles.searchResults}>
                            {searchData && searchData.map((singleItem, index)=>(
                                <SingleSearchGun 
                                    title={singleItem.title}
                                    img={singleItem.img}
                                    key={singleItem.title+index}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchSection;